import getLocalString from "constants/Localization";
import { useCustomSetJobDepositCollectedMutation } from "generated/graphql";
import useBitumioMutation from "hooks/useBitumioMutation";

export default function useSetJobDepositCollected() {
  const [mutation, { loading, data, error }] = useCustomSetJobDepositCollectedMutation({
    refetchQueries: ["customGetJob", "customGetJobs", "customGetJobDepositStatus"],
  });

  return useBitumioMutation(
    {
      mutation,
      loading,
      data,
      error,
      key: "setJobDepositCollected",
    },
    {
      successMessage: getLocalString("jobs.update-job-deposit-status-success"),
      failureMessage: getLocalString("jobs.update-job-deposit-status-failure"),
    }
  );
}
